<div class="info-strip grid clearfix">
  <div class="info-strip-left grid">
    <button class="back-button" type="button" (click)="back('/rec-plan-bp-search')">
      <i class="fa fa-caret-left"></i><p>Back</p>
    </button>
  </div>
  <div class="info-strip-right grid">
    <div class="criteria">
      <h2>Recorded Land Plan Search Results</h2>
      <p>
        <strong>Book:</strong> {{ recs.coresearchdata.bp.bp[0].docNumPrimary }}   <strong>Page:</strong> {{recs.coresearchdata.bp.bp[0].docNumSecondary}}   <strong>{{recordCount}}</strong> records found
      </p>
    </div>
  </div>
</div>
